import { useQuery } from 'react-query';
import { DOCUMENT } from '../../constants/queryKeys';
import useAxiosInstance from '../useAxiosInstance';
import { getEntityFieldValuesByFieldName } from '../../services/ConfigService/EntityService';

export default function useGetEntityFieldValuesQuery(
  entityName: string,
  fieldName: string
) {
  const { axios } = useAxiosInstance();
  return useQuery<string[]>(
    [DOCUMENT, entityName, fieldName],
    async () => getEntityFieldValuesByFieldName(axios, entityName, fieldName),
    { enabled: !!fieldName }
  );
}
